import settings from "@/settings.json";

export const getContentFullUrl = (contentStorageName: string) => {
  if (contentStorageName?.startsWith("http")) {
    return contentStorageName;
  }
  return `${settings.ContentSource}${contentStorageName}`;
};

export const getIsEndDatePassed = (endDate: string) => {
  const isEndDatePassed = endDate ? new Date().getTime() > new Date(endDate + "Z").getTime() : false;
  return isEndDatePassed;
};

export const getIsStartDatePassed = (startDate: string) => {
  const isStartDatePassed = startDate ? new Date().getTime() < new Date(startDate + "Z").getTime() : false;
  return isStartDatePassed;
};

export const getIsEndDateExpiringSoon = (endDate: string) => {
  const endDaysExpiringSoon = 3;
  const isEndDateExpiringSoon = endDate
    ? new Date().getTime() < new Date(endDate + "Z").getTime() + 1000 * 60 * 60 * 24 * endDaysExpiringSoon
    : false;
  return isEndDateExpiringSoon;
};
